import { useMutation } from '@tanstack/react-query';
import saveAs from 'save-as';
import moment from 'moment';

import { useToast } from 'Store/toast';
import { useLoader } from 'Store/loader';
import { exportReportText } from 'Const/report-attendance/text';
import getExportOperatorPresence from 'Api/report-attendance-operator/getExportOperatorPresence';

import getExportOperatorPresenceRequest from './model/request/getExportOperatorPresenceRequest';

const useGetExportOperatorPresence = () => {
  const { onShowLoader, onResetLoader } = useLoader();
  const { onOpenToast } = useToast();

  return useMutation({
    mutationFn: async (filter) => {
      onShowLoader({ variant: 'loader-primary' });
      const queries = getExportOperatorPresenceRequest(filter);

      const response = await getExportOperatorPresence(queries);

      return { response, monthYear: filter.monthYear };
    },
    onSuccess: ({ response, monthYear }) => {
      const filename = `Report Attendance ${moment(monthYear).format('MM-YYYY')}.xlsx`;

      const blob = new Blob([response]);

      saveAs(blob, filename);

      onOpenToast({
        status: 'success',
        description: exportReportText.successExportText,
        duration: 3,
        alwaysShow: false,
      });
    },
    onError: (error) => {
      console.log(error);

      onOpenToast({
        status: 'error',
        description: exportReportText.failedExportText,
        duration: 5,
        alwaysShow: false,
      });
    },
    onSettled: () => onResetLoader(),
  });
};

export default useGetExportOperatorPresence;
